// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title___WSlY","tips":"styles_tips__2tBlt","confirmBtn":"styles_confirmBtn__1pByV","secretParagraph":"styles_secretParagraph__3nqfl","link":"styles_link__2eBpW"};